export default "__VITE_ASSET__DyX0fSkH__"